import React, {useEffect, useState} from 'react'
import LinearProgress from '@mui/material/LinearProgress';
import './step_three.scss';
import LoadingImage from '../../../images/LoadingImage.png';
import { onboard_steps_path, onboard_step_path } from '../../../routes';

const StepThree = () => {
  const [progress, setProgress] = useState(0);
  let isFinalized = false

  const handleFinalSetup = async () => {
    const submitValues = {
      id: 3,
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submitValues)
    };
    fetch(onboard_steps_path({format: 'json'}), requestOptions)
    .then(async response => {
      if (response.ok) {
        isFinalized = true
      } else {
        return Promise.reject(nameError)
      }
    })
    .catch(error => {
        console.log('ERROR!', error)
    })

  }
  useEffect(() => {
    handleFinalSetup()
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100 && isFinalized) {
          window.location = onboard_step_path(4)
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className='loading-step'>
      <div className='wrapper'>
        <div className='title'>
          Configuring your HubbleIQ dashboard
        </div>
        <LinearProgress variant="determinate" value={progress}/>
        <div className='image-container'>
          <img src={LoadingImage} alt="HubbleIQ Dashboard"/>
        </div>
      </div>
    </div>
  )
}

export default StepThree;